<template>
    <v-layout row wrap>
        <v-flex xs0 sm2 md3 lg4 />
        <v-flex xs12 sm8 md6 lg4>
            <slot />
        </v-flex>
        <v-flex xs0 sm2 md3 lg4 />
        <v-flex xs12 class="full_content">
            <v-layout row wrap>
                <v-flex xs12 sm6 md8 class="custom_flex_padding_right">
                    <h3 class="custom_text_add_field">
                        Saisie des données
                    </h3>
                    <v-flex xs12>
                        <v-img v-if="file.path !== '' && isImage(file.name)"
                               :src="$cdnPath + file.path"
                               aspect-ratio="1" class="grey lighten-2" max-height="300">
                            <template v-slot:placeholder>
                                <v-row class="fill-height ma-0" align="center" justify="center">
                                    <v-progress-circular indeterminate color="grey lighten-5" />
                                </v-row>
                            </template>
                        </v-img>
                        <iframe v-else-if="file.path !== '' && isVideo(file.name)"
                                class="iframe_render_content_360"
                                :src="$cdnPath + file.path" />
                        <v-slider v-model="alphaOffset" min="-180" max="180" hide-details />
                        <v-text-field v-model="alphaOffset" type="number" filled mask="###"
                                      label="Orientation X (°)" min="-180" max="180" />
                        <v-file-input v-model="videoImageFiles" :accept="videoImageTypes"
                                      label="Ajoutez un contenu 360" filled :rules="videoImageRules"
                                      class="content360_file_upload" @change="onChangeVideoImage" />
                    </v-flex>
                    <v-flex xs12>
                        <v-switch v-model="north"
                                  :label="north ? 'Fixer l\'orientation au nord: Oui' : 'Fixer l\'orientation au nord: Non'" />
                    </v-flex>
                    <v-layout class="publish_btn">
                        <v-flex xs6 />
                        <v-flex xs6>
                            <v-btn class="custom_btn_add_field custom_btn_color_blue"
                                   :loading="fileUploading" :disabled="!videoImageValid" @click="updateAction">
                                Publier les changements
                                <template v-slot:loader>
                                    <span class="custom-loader">
                                        <v-icon light>cached</v-icon>
                                    </span>
                                </template>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex x0 sm6 md4 class="custom_flex_padding_left">
                    <h3 class="custom_text_add_field">
                        Image à scanner
                    </h3>
                    <p v-if="imageToScan" class="custom_text_add_field_p">
                        Testez votre story en scannant cette image depuis votre téléphone
                    </p>
                    <p v-else class="custom_text_add_field_p">
                        Pour tester votre augmentation, veuillez ajouter une image dans l'onglet Paramètres.
                    </p>
                    <v-img v-if="imageToScan" :src="imageToScan"
                           aspect-ratio="1" class="grey lighten-2">
                        <template v-slot:placeholder>
                            <v-layout fill-height align-center justify-center ma-0>
                                <v-progress-circular indeterminate color="grey lighten-5" />
                            </v-layout>
                        </template>
                    </v-img>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { fileMixinVideoImage } from '../../global/FileMixinVideoImage';

    export default {
        name: 'Content360',
        mixins: [fileMixinVideoImage],
        computed: {
            ...mapGetters('actions', ['action']),
            file: {
                get () {
                    return this.$store.state.actions.content360.currentContent360.file;
                },
                set (file) {
                    this.$store.commit('actions/content360/SET_DATA', { file });
                }
            },
            north: {
                get () {
                    return this.$store.state.actions.content360.currentContent360.north;
                },
                set (north) {
                    this.$store.commit('actions/content360/SET_DATA', { north });
                }
            },
            alphaOffset: {
                get () {
                    return this.$store.state.actions.content360.currentContent360.alphaOffset;
                },
                set (alphaOffset) {
                    this.$store.commit('actions/content360/SET_DATA', { alphaOffset });
                }
            },
            imageToScan: function () {
                return this.$store.state.actions.augmentation.image_id
                    ? '/image/' + this.$store.state.actions.augmentation.image_id : null;
            },
            isImage: function () {
                return (name) => {
                    return name.endsWith('.png') || name.endsWith('.jpeg') || name.endsWith('.jpg');
                };
            },
            isVideo: function () {
                return (name) => {
                    return name.endsWith('.mp4') || name.endsWith('.webm');
                };
            }
        },
        watch: {
            checkEdit: function () {
                this.$emit('edit-result', true);
            },
            videoImageData: function (newValue) {
                if (newValue) {
                    this.file = newValue;
                }
            }
        },
        mounted () {
            this.emitVerification();
            this.initVideoImageFiles(this.file, this.$cdnPath);
            this.dragAndDrop('.content360_file_upload', this.onChangeContent, this.videoImageTypes);
        },
        methods: {
            ...mapActions('actions/content360', ['content360Update']),
            dragAndDrop: function (element, callback) {
                this.$el.querySelector(element).addEventListener('drop', (e) => {
                    e.preventDefault();
                    if (this.validateVideoImage(e.dataTransfer.files[0])) {
                        callback(e.dataTransfer.files[0]);
                    } else {
                        this.$toasted.error('Type of file don\'t accepted');
                    }
                });
                this.$el.querySelector(element).addEventListener('dragleave', (e) => {
                    e.preventDefault();
                });
                this.$el.querySelector(element).addEventListener('dragover', (e) => {
                    e.preventDefault();
                });
            },
            emitVerification: function () {
                this.$emit('verificationValues', {
                    state: true,
                    data: {}
                });
            },
            updateAction: function () {
                this.content360Update().then(() => {
                    this.$toasted.success('Changement correctement pris en compte.');
                }).catch((err) => {
                    this.$toasted.error(err);
                });
            }
        }
    };
</script>

<style scoped>
    .layout {
        width: 100%;
        margin: 0;
    }

    #video_360_section .full_content {
        background-color: rgba(0, 0, 0, 0.05);
        padding: 10px 20px 20px 20px !important;
        min-height: calc(100vh - 215px);
    }

    .custom_text_add_field {
        margin-right: 10px;
        width: 100%;
        margin-bottom: 15px;
        text-align: center;
        margin-top: 10px;
    }

    .custom_flex_data {
        padding-left: 20px !important;
        padding-right: 20px !important;
    }

    .custom_video_input {
        width: 100%;
        padding: 5px;
        background-color: rgba(0, 0, 0, 0.06);
        color: rgba(0, 0, 0, .54);
        border-bottom: 2px solid rgba(0, 0, 0, 0.35);
        margin-bottom: 25px;
        transition: all 0.1s ease-in;
        cursor: pointer;
    }

    .custom_btn_select_file {
        width: 140px;
        background-color: #393E46 !important;
    }

    .custom_text_select_file {
        display: inline-block;
        vertical-align: middle;
    }

    .display_none_input {
        display: none;
    }

    .custom_video_input:hover, .custom_video_input:focus {
        background-color: rgba(0, 0, 0, 0.1);
        border-bottom: 2px solid rgba(0, 0, 0, 0.80);
        transition: all 0.1s ease-in;
    }

    .iframe_render_content_360 {
        width: 100%;
        height: 300px;
    }

    .content360_file_upload {
        margin-top: 25px;
    }

    .publish_btn {
        position: relative;
    }

    .publish_btn button {
        width: 100%;
        color: white !important;
        font-weight: 600 !important;
        text-transform: initial !important;
    }

    .custom_flex_padding_right {
        padding-right: 20px !important;
    }

    .custom_flex_padding_left {
        padding-left: 20px !important;
    }

</style>
